import { OnInit } from '@angular/core';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { Logger, CryptoUtils } from 'msal';
import { PromptState } from 'msal/lib-commonjs/utils/Constants';

export abstract class BaseAutorizeComponent implements OnInit {
  isIframe: boolean = false;
  public loggedIn: boolean;

  abstract onInitChild();

  constructor(protected broadcastService: BroadcastService, protected authService: MsalService) { 
    this.loggedIn = false;
  }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;

    this.checkoutAccount();

    this.broadcastService.subscribe('msal:loginSuccess', () => {
      this.checkoutAccount();
     
    });

    this.authService.handleRedirectCallback((authError, response) => {
      if (authError) {
        console.error('Redirect Error: ', authError.errorMessage);
        return;
      }
      
      console.log('Redirect Success: ', response.accessToken);
    });

    this.authService.setLogger(new Logger((logLevel, message, piiEnabled) => {
      console.log('MSAL Logging: ', message);
    }, {
      correlationId: CryptoUtils.createNewGuid(),
      piiLoggingEnabled: false
    }));
  }

  checkoutAccount() {
    this.loggedIn = !!this.authService.getAccount();
    if(this.loggedIn){
      this.onInitChild();
    }
  }

  login() {
    const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

    if (isIE) {
      this.authService.loginRedirect({prompt: PromptState.SELECT_ACCOUNT});
    } else {
      this.authService.loginPopup({prompt: PromptState.SELECT_ACCOUNT, state: "866ss5"});
    }
  }

  logout() {
    this.authService.logout();
  }
}